import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { listLastUserCompanies } from '../api/last-user-company-service';

export interface Company {
    id: string;
    name: string;
    userId?: string;
    createdUserId?: string;
    expertiseArea?: string;
    country?: string;
    city?: string;
    description?: string;
    website?: string;
    email?: string;
    phone?: string;
    logo?: string;
}

interface CompaniesState {
    companies: Company[];
    selectedCompany: Company | null;
    isLoading: boolean;
    error: string | null;
}

const initialState: CompaniesState = {
    companies: [],
    selectedCompany: null,
    isLoading: false,
    error: null,
};

// Async thunks
export const fetchCompanies = createAsyncThunk('companies/fetchCompanies', async () => {
    const response = await listLastUserCompanies();
    return response.data;
});

const companiesSlice = createSlice({
    name: 'companies',
    initialState,
    reducers: {
        setSelectedCompany: (state, action: PayloadAction<Company | null>) => {
            state.selectedCompany = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCompanies.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchCompanies.fulfilled, (state, action) => {
                state.isLoading = false;
                // FAZ 5 / F5-10 — `fetchAllPagesVia` her zaman `{ data: T[] }`
                // donduruyor (hem eski hem yeni backend seklini normalize
                // ediyor), yani eski savunmaci `?.data ?? ?.items` zinciri
                // artik olu kod.
                const data = action.payload;
                state.companies = Array.isArray(data) ? data : [];
            })
            .addCase(fetchCompanies.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message || 'Failed to fetch companies';
            });
    },
});

export const { setSelectedCompany, clearError } = companiesSlice.actions;
export default companiesSlice.reducer;
